export default {
    view: "Home"
};